/* ==========================================================================
   KEIS — product page behaviour
   ========================================================================== */
(function () {
  'use strict';

  /* See theme.liquid — every string here is translated by Liquid before it
     reaches the page. The second argument is a last-resort English fallback for
     the case where that block did not render, not the normal path. */
  function T(key, fallback) {
    var bag = (window.KEIS && window.KEIS.strings) || {};
    return bag[key] != null ? bag[key] : fallback;
  }

  var money = function (c) { return window.KEIS.money(c); };

  /* ========================================================= <keis-variants>
     Option pickers -> matching variant. Updates price, availability, stock
     line, gallery position, the hidden id input and the URL.
     ========================================================================= */

  var KeisVariants = (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.setPrototypeOf(El, HTMLElement);

    El.prototype.connectedCallback = function () {
      var self = this;
      var data = this.querySelector('[data-variant-json]');
      if (!data) return;
      this.variants = JSON.parse(data.textContent);
      this.idInput = document.querySelector('[data-variant-id]');
      this.selected = this.getSelectedOptions();

      this.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-option-value]');
        if (!opt || opt.hasAttribute('disabled')) return;
        e.preventDefault();
        var index = Number(opt.dataset.optionIndex);
        self.selected[index] = opt.dataset.optionValue;
        self.syncPressed(index, opt);
        self.update();
      });
      this.addEventListener('change', function (e) {
        var sel = e.target.closest('select[data-option-index]');
        if (!sel) return;
        self.selected[Number(sel.dataset.optionIndex)] = sel.value;
        self.update();
      });

      this.update(true);
    };

    El.prototype.getSelectedOptions = function () {
      var out = [];
      this.querySelectorAll('[data-option-value][aria-pressed="true"]').forEach(function (el) {
        out[Number(el.dataset.optionIndex)] = el.dataset.optionValue;
      });
      this.querySelectorAll('select[data-option-index]').forEach(function (el) {
        out[Number(el.dataset.optionIndex)] = el.value;
      });
      return out;
    };

    El.prototype.syncPressed = function (index, chosen) {
      this.querySelectorAll('[data-option-index="' + index + '"][data-option-value]').forEach(function (el) {
        el.setAttribute('aria-pressed', el === chosen ? 'true' : 'false');
      });
      var label = this.querySelector('[data-option-label="' + index + '"]');
      if (label) label.textContent = chosen.dataset.optionValue;
    };

    El.prototype.match = function () {
      var sel = this.selected;
      return this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] === undefined || sel[i] === o; });
      })[0];
    };

    El.prototype.update = function (initial) {
      var variant = this.match();
      this.markAvailability();

      if (!variant) {
        this.setButton(false, this.dataset.unavailable || T('unavailable', 'Sold Out'));
        this.preorderNote(null);
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;

      if (!initial) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      /* Price */
      var priceEl = document.querySelector('[data-price-block]');
      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('keis-price--on-sale', !!onSale);
        var amount = priceEl.querySelector('[data-price-amount]');
        var compare = priceEl.querySelector('[data-price-compare]');
        if (amount) amount.innerHTML = money(variant.price);
        if (compare) {
          compare.innerHTML = onSale ? money(variant.compare_at_price) : '';
          compare.hidden = !onSale;
        }
      }

      /* Instalment line */
      var inst = document.querySelector('[data-instalment]');
      if (inst) inst.innerHTML = money(Math.round(variant.price / 3));

      /* Stock line — truthful urgency, driven from inventory not a timer. */
      this.stockLine(variant);

      /* SKU, everywhere it is shown: above the title and in the
         Specifications drawer. The drawer's row hides when this variant has
         no SKU rather than showing a label with nothing after it. */
      document.querySelectorAll('[data-variant-sku]').forEach(function (el) {
        el.textContent = variant.sku || '';
      });
      document.querySelectorAll('[data-spec-sku-row]').forEach(function (row) {
        row.hidden = !variant.sku;
      });

      /* Weight, in the Specifications drawer. */
      document.querySelectorAll('[data-variant-weight]').forEach(function (el) {
        el.textContent = variant.weight || '';
      });
      document.querySelectorAll('[data-spec-weight-row]').forEach(function (row) {
        row.hidden = !variant.weight;
      });

      /* Sticky card title tracks the chosen variant. */
      var stickyTitle = document.querySelector('[data-sticky-title]');
      if (stickyTitle && stickyTitle.dataset.base === undefined) {
        stickyTitle.dataset.base = (stickyTitle.textContent || '').split(' · ')[0].trim();
      }
      if (stickyTitle) {
        stickyTitle.textContent = variant.title && variant.title !== 'Default Title'
          ? stickyTitle.dataset.base + ' · ' + variant.title
          : stickyTitle.dataset.base;
      }

      /* Move the gallery to this variant's image.

         In the two-column layout every image is already on the page, so the
         only thing worth doing is bringing the right one into view — and only
         when it is actually off screen, because yanking the page while someone
         is picking a size is worse than leaving it alone. */
      if (!initial && variant.featured_media) {
        var stage = document.querySelector('[data-gallery-slides]');
        var slide = stage && stage.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) {
          var gallery = stage.closest && stage.closest('keis-gallery');
          if (gallery && typeof gallery.goTo === 'function') {
            gallery.goTo(Array.prototype.indexOf.call(stage.children, slide));
          } else {
            stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      this.setButton(variant.available, this.labelFor(variant));
      this.preorderNote(variant);

      document.dispatchEvent(new CustomEvent('keis:variant:change', { detail: { variant: variant } }));
    };

    /* Cross out option values with no available variant in the current combo. */
    El.prototype.markAvailability = function () {
      var self = this;
      this.querySelectorAll('[data-option-value]').forEach(function (el) {
        var index = Number(el.dataset.optionIndex);
        var probe = self.selected.slice();
        probe[index] = el.dataset.optionValue;
        var exists = self.variants.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            return i === index ? probe[i] === o : (probe[i] === undefined || probe[i] === o);
          });
        });
        el.toggleAttribute('disabled', !exists);
        el.setAttribute('aria-disabled', String(!exists));
      });
    };

    /* Mirrors the Liquid in snippets/product-inventory.liquid so the line stays
       correct as variants change. Every figure comes from real inventory. */
    El.prototype.stockLine = function (variant) {
      var el = document.querySelector('[data-stock-line]');
      if (!el) return;
      var d = el.dataset;
      /* The page never carries the real stock level: the variant JSON gives
         "stock" (untracked / none / some) and, only where the line prints a
         number, "stock_count" already rounded the way the Liquid rounds it. */
      var count = variant.stock_count;
      var low = Number(d.low || 5);
      var band = Number(d.band || 10);
      var showLow = d.showLow !== 'false';
      var mode = d.mode || 'banded';

      var state, text;
      if (!variant.available) {
        state = 'out';  text = d.textOut;
      } else if (variant.stock === 'untracked') {
        state = 'in';   text = d.textIn;
      } else if (variant.stock === 'none') {
        state = 'backorder'; text = d.textBackorder;
      } else if (count != null && count <= low && showLow) {
        state = 'low';  text = (d.textLow || '').replace('{count}', count);
      } else if (count != null && mode === 'exact') {
        state = 'in';   text = (d.textExact || '').replace('{count}', count);
      } else if (count != null && mode === 'banded') {
        state = 'in';
        /* Fewer units than a full band arrive as the real number. */
        text = count < band
          ? (d.textExact || '').replace('{count}', count)
          : (d.textBanded || '').replace('{count}', count);
      } else {
        state = 'in';   text = d.textIn;
      }

      el.className = 'keis-stockline keis-stockline--' + state;
      el.querySelector('[data-stock-text]').textContent = text || '';
    };

    /* Sellable with nothing on the shelf is a pre-order, not a normal add.
       Shopify still reports available:true because inventory_policy is
       'continue', so availability alone cannot tell the two apart. */
    El.prototype.isPreorder = function (variant) {
      return variant.preorder === true;
    };

    El.prototype.labelFor = function (variant) {
      if (!variant.available) return this.dataset.soldOut || T('soldOut', 'Sold Out');
      if (this.isPreorder(variant)) {
        return this.dataset.preorderLabel || T('preorder', 'Pre-Order');
      }
      return this.dataset.addLabel || T('addToCart', 'Buy Now');
    };

    /* The pre-order note under the button ("Ships in November"): only while
       this size is a pre-order, and only between the note's own dates — read
       as today in the shop's time zone, because the page may have been built
       yesterday (see product-buy-buttons.liquid). ?keis_date=2026-11-01
       previews another day, as it does for the holiday banner. */
    El.prototype.preorderNote = function (variant) {
      var notes = document.querySelectorAll('[data-preorder-note]');
      if (!notes.length) return;
      var q = /[?&]keis_date=(\d{4}-\d{2}-\d{2})/.exec(window.location.search);
      Array.prototype.forEach.call(notes, function (el) {
        var day = q ? q[1] : null;
        if (!day) {
          try {
            var p = new Intl.DateTimeFormat('en-GB', {
              timeZone: el.getAttribute('data-tz') || 'Europe/London',
              year: 'numeric', month: '2-digit', day: '2-digit'
            }).formatToParts(new Date());
            var g = function (t) { return (p.find(function (x) { return x.type === t; }) || {}).value; };
            day = g('year') + '-' + g('month') + '-' + g('day');
          } catch (e) {
            day = el.getAttribute('data-today');
          }
        }
        var from = el.getAttribute('data-from') || '';
        var until = el.getAttribute('data-until') || '';
        var inDates = (!from || day >= from) && (!until || day <= until);
        el.hidden = !(variant && variant.preorder === true && inDates);
      });
    };

    El.prototype.setButton = function (available, label) {
      var preorder = label === (this.dataset.preorderLabel || '\u0000');
      document.querySelectorAll('[data-add-button]').forEach(function (btn) {
        btn.disabled = !available;
        btn.toggleAttribute('data-preorder', preorder);
        var text = btn.querySelector('[data-add-label]') || btn;
        text.textContent = label;
      });
    };

    return El;
  })();
  if (!customElements.get('keis-variants')) customElements.define('keis-variants', KeisVariants);

  /* ============================================================ PDP drawers
     Whether a section is a drawer is a per-breakpoint choice, and a <details>
     cannot be forced open from CSS. Where the merchant turned the drawer off,
     open it and stamp .is-static so the stylesheet can hide the summary and
     show the standing heading instead.

     A drawer the customer had closed is remembered, so crossing the breakpoint
     twice does not silently open something they had shut.
     ===================================================================== */
  (function () {
    var wide = window.matchMedia('(min-width: 990px)');

    function apply() {
      var onDesktop = wide.matches;
      var list = document.querySelectorAll('.keis-pdp__drawer');
      Array.prototype.forEach.call(list, function (d) {
        var flag = onDesktop ? d.getAttribute('data-drawer-desktop')
                             : d.getAttribute('data-drawer-mobile');
        var isDrawer = flag !== 'false';

        d.classList.toggle('is-static', !isDrawer);

        if (!isDrawer) {
          if (!d.open) { d.dataset.reopen = '1'; d.open = true; }
        } else if (d.dataset.reopen === '1') {
          d.open = false;
          delete d.dataset.reopen;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }
    if (wide.addEventListener) wide.addEventListener('change', apply);
    else if (wide.addListener) wide.addListener(apply);
    /* Re-render in the theme editor replaces the markup. */
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:block:select', apply);
  })();

  /* ========================================================== <keis-gallery> */

  var KeisGallery = (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.setPrototypeOf(El, HTMLElement);

    El.prototype.connectedCallback = function () {
      var self = this;
      this.slides = this.querySelector('[data-gallery-slides]');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.slides) return;

      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.goTo(i); });
      });
      var next = this.querySelector('[data-gallery-next]');
      if (next) next.addEventListener('click', function () { self.goTo(self.current() + 1); });
      var prev = this.querySelector('[data-gallery-prev]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.current() - 1); });

      this.initZoom();

      this.slides.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { self.syncThumbs(self.current()); });
      }, { passive: true });
    };

    /* Cursor-tracking zoom. The transform origin follows the pointer, so the
       part of the garment under the cursor is what magnifies. Pointer devices
       only — on touch the swipe gesture owns the gallery. */
    El.prototype.initZoom = function () {
      /* Three modes. The lightbox works on touch as well as with a mouse, so it
         is not gated on hover the way the magnifier has to be. */
      var mode = this.dataset.zoomMode || 'lightbox';
      if (mode === 'none') return;
      if (mode === 'lightbox') return this.initLightbox();
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      var scale = this.dataset.zoomScale || '2';
      this.classList.add('keis-gallery--zoomable');

      Array.prototype.forEach.call(this.querySelectorAll('.keis-gallery__slide'), function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;                       /* video and 3D media stay untouched */
        slide.style.setProperty('--zoom-scale', scale);

        slide.addEventListener('mouseenter', function () { slide.classList.add('is-zoomed'); });
        slide.addEventListener('mouseleave', function () {
          slide.classList.remove('is-zoomed');
          slide.style.removeProperty('--zoom-x');
          slide.style.removeProperty('--zoom-y');
        });
        slide.addEventListener('mousemove', function (e) {
          var r = slide.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          slide.style.setProperty('--zoom-x', Math.max(0, Math.min(100, x)) + '%');
          slide.style.setProperty('--zoom-y', Math.max(0, Math.min(100, y)) + '%');
        });
      });
    };

    /* ---- Lightbox ----------------------------------------------------------
       Click the image, it opens full screen. Plus and minus step the zoom, and
       once magnified the image can be dragged. Panning is clamped to the image's
       own edges, so it can never be dragged off into empty space and lost. */
    El.prototype.initLightbox = function () {
      var self = this;
      /* The dialog lives outside the media column — a sticky ancestor would trap
         it in its own stacking context and let the rest of the page paint over
         an open lightbox — so look for it across the whole section. */
      var scope = this.closest('.shopify-section') || document;
      var dialog = scope.querySelector('[data-zoom-dialog]');
      if (!dialog) return;

      this.zoomDialog = dialog;
      this.zoomImg = dialog.querySelector('[data-zoom-img]');
      this.zoomStage = dialog.querySelector('[data-zoom-stage]');
      this.zoomLevelEl = dialog.querySelector('[data-zoom-level]');
      this.zoomTiles = Array.prototype.slice.call(dialog.querySelectorAll('[data-zoom-pick]'));

      var inBtn = dialog.querySelector('[data-zoom-in]');
      var outBtn = dialog.querySelector('[data-zoom-out]');

      this.classList.add('keis-gallery--lightbox');

      Array.prototype.forEach.call(
        this.querySelectorAll('.keis-gallery__slide'),
        function (slide) {
          slide.addEventListener('click', function () {
            self.openZoom(parseInt(slide.dataset.index || '0', 10) || 0);
          });
        },
      );

      if (inBtn) inBtn.addEventListener('click', function () { self.stepZoom(0.5); });
      if (outBtn) outBtn.addEventListener('click', function () { self.stepZoom(-0.5); });

      var zPrev = dialog.querySelector('[data-zoom-prev]');
      var zNext = dialog.querySelector('[data-zoom-next]');
      if (zPrev) zPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        self.showZoom(self.zoomIndex - 1);
      });
      if (zNext) zNext.addEventListener('click', function (e) {
        e.stopPropagation();
        self.showZoom(self.zoomIndex + 1);
      });

      this.zoomTiles.forEach(function (t) {
        t.addEventListener('click', function () {
          self.showZoom(parseInt(t.dataset.zoomPick, 10) || 0);
        });
      });

      /* Double-click toggles between fit and 2x, which is what people try first. */
      if (this.zoomStage) {
        this.zoomStage.addEventListener('dblclick', function () {
          self.setZoom(self.zoomScale > 1 ? 1 : 2);
        });
      }

      this.initZoomDrag();

      document.addEventListener('keis:drawer:close', function (e) {
        if (e.detail && e.detail.id === dialog.id) self.setZoom(1);
      });
      /* Arrow keys move between images while the lightbox is open. */
      document.addEventListener('keydown', function (e) {
        if (!dialog.hasAttribute('open')) return;
        if (e.key === 'ArrowRight') self.showZoom(self.zoomIndex + 1);
        if (e.key === 'ArrowLeft') self.showZoom(self.zoomIndex - 1);
      });
    };

    El.prototype.openZoom = function (index) {
      if (!this.zoomDialog) return;
      this.showZoom(index);
      if (typeof this.zoomDialog.open === 'function') this.zoomDialog.open();
    };

    El.prototype.showZoom = function (index) {
      var slides = this.querySelectorAll('.keis-gallery__slide');
      if (!slides.length || !this.zoomImg) return;
      var i = ((index % slides.length) + slides.length) % slides.length;
      this.zoomIndex = i;

      var img = slides[i].querySelector('img');
      if (img) {
        /* The 2400px source is only attached now — fetching one per shot up front
           would double the weight of a page that has already loaded the gallery. */
        this.zoomImg.src = img.dataset.full || img.currentSrc || img.src;
        this.zoomImg.alt = img.alt || '';
      }
      this.zoomTiles.forEach(function (t, j) {
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      this.setZoom(1);
    };

    El.prototype.setZoom = function (scale, skipTransition) {
      this.zoomScale = Math.min(4, Math.max(1, scale));
      if (this.zoomScale === 1) { this.zoomX = 0; this.zoomY = 0; }
      this.clampPan();
      this.paintZoom(skipTransition);
      this.syncZoomChrome();
    };

    /* Button states and the readout. Split out of setZoom because a pinch drives
       the scale directly and still has to keep them honest. */
    El.prototype.syncZoomChrome = function () {
      var dialog = this.zoomDialog;
      if (dialog) {
        var inBtn = dialog.querySelector('[data-zoom-in]');
        var outBtn = dialog.querySelector('[data-zoom-out]');
        if (inBtn) inBtn.disabled = this.zoomScale >= 4;
        if (outBtn) outBtn.disabled = this.zoomScale <= 1;
      }
      if (this.zoomLevelEl) {
        this.zoomLevelEl.textContent = Math.round(this.zoomScale * 100) + '%';
      }
      if (this.zoomStage) {
        this.zoomStage.classList.toggle('is-fit', this.zoomScale <= 1);
      }
    };

    El.prototype.stepZoom = function (by) {
      this.setZoom((this.zoomScale || 1) + by);
    };

    El.prototype.paintZoom = function (skipTransition) {
      if (!this.zoomImg) return;
      var img = this.zoomImg;
      if (skipTransition) {
        img.classList.remove('is-stepping');
      } else {
        img.classList.add('is-stepping');
        window.setTimeout(function () { img.classList.remove('is-stepping'); }, 260);
      }
      img.style.transform =
        'translate(' + (this.zoomX || 0) + 'px,' + (this.zoomY || 0) + 'px) scale(' + (this.zoomScale || 1) + ')';
    };

    /* Keep the image covering the stage: at any zoom the pan is limited to the
       overhang, so there is no way to drag the photograph off screen. */
    El.prototype.clampPan = function () {
      if (!this.zoomImg || !this.zoomStage) return;
      /* getBoundingClientRect reports the size AFTER the transform, so these are
         already the on-screen dimensions at the current zoom. */
      var img = this.zoomImg.getBoundingClientRect();
      var stage = this.zoomStage.getBoundingClientRect();
      var maxX = Math.max(0, (img.width - stage.width) / 2);
      var maxY = Math.max(0, (img.height - stage.height) / 2);
      this.zoomX = Math.min(maxX, Math.max(-maxX, this.zoomX || 0));
      this.zoomY = Math.min(maxY, Math.max(-maxY, this.zoomY || 0));
    };

    /**
     * One pointer drags, two pinch.
     *
     * Both live in the same handler because they are the same gesture stream: a
     * second finger can land mid-drag and a pinch can end with one finger still
     * down, and tracking them separately loses the transition between the two.
     * Pointer events cover mouse, pen and touch, so there is no separate touch
     * path to keep in step.
     */
    El.prototype.initZoomDrag = function () {
      var self = this;
      var stage = this.zoomStage;
      if (!stage) return;

      var points = {};      /* live pointers by id */
      var drag = null;      /* single-finger pan origin */
      var pinch = null;     /* two-finger origin */

      function count() { return Object.keys(points).length; }

      function spread() {
        var ids = Object.keys(points);
        var a = points[ids[0]], b = points[ids[1]];
        return Math.hypot(a.x - b.x, a.y - b.y);
      }
      function midpoint() {
        var ids = Object.keys(points);
        var a = points[ids[0]], b = points[ids[1]];
        return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      }

      stage.addEventListener('pointerdown', function (e) {
        /* The arrows live inside the drag surface; pressing one is a click, not
           the start of a pan. */
        if (e.target.closest('.keis-zoom__nav')) return;

        points[e.pointerId] = { x: e.clientX, y: e.clientY };
        try { stage.setPointerCapture(e.pointerId); } catch (err) { /* not capturable */ }

        if (count() === 2) {
          drag = null;
          pinch = {
            spread: spread(),
            mid: midpoint(),
            scale: self.zoomScale || 1,
            x: self.zoomX || 0,
            y: self.zoomY || 0,
          };
          stage.classList.remove('is-grabbing');
        } else if (count() === 1 && (self.zoomScale || 1) > 1) {
          drag = { x: e.clientX, y: e.clientY, ox: self.zoomX || 0, oy: self.zoomY || 0 };
          stage.classList.add('is-grabbing');
        }
      });

      stage.addEventListener('pointermove', function (e) {
        if (!points[e.pointerId]) return;
        points[e.pointerId] = { x: e.clientX, y: e.clientY };

        if (pinch && count() >= 2) {
          var ratio = spread() / (pinch.spread || 1);
          var mid = midpoint();
          self.zoomScale = Math.min(4, Math.max(1, pinch.scale * ratio));
          /* Follow the fingers, so the picture tracks the gesture instead of
             zooming about the centre while the hand moves somewhere else. */
          self.zoomX = pinch.x + (mid.x - pinch.mid.x);
          self.zoomY = pinch.y + (mid.y - pinch.mid.y);
          if (self.zoomScale <= 1) { self.zoomX = 0; self.zoomY = 0; }
          self.clampPan();
          self.paintZoom(true);
          self.syncZoomChrome();
          return;
        }

        if (drag) {
          self.zoomX = drag.ox + (e.clientX - drag.x);
          self.zoomY = drag.oy + (e.clientY - drag.y);
          self.clampPan();
          self.paintZoom(true);
        }
      });

      function release(e) {
        delete points[e.pointerId];
        try { stage.releasePointerCapture(e.pointerId); } catch (err) { /* already released */ }

        if (count() < 2) pinch = null;
        if (count() === 0) {
          drag = null;
          stage.classList.remove('is-grabbing');
          /* Settle on a clean value rather than whatever the pinch ended on. */
          self.setZoom(Math.round((self.zoomScale || 1) * 20) / 20, true);
        } else if (count() === 1 && (self.zoomScale || 1) > 1) {
          /* A pinch that lost a finger becomes a drag from where it is. */
          var id = Object.keys(points)[0];
          drag = { x: points[id].x, y: points[id].y, ox: self.zoomX || 0, oy: self.zoomY || 0 };
        }
      }
      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);

      /* Wheel zooms rather than scrolling the page behind the dialog. */
      stage.addEventListener('wheel', function (e) {
        e.preventDefault();
        self.stepZoom(e.deltaY < 0 ? 0.25 : -0.25);
      }, { passive: false });
    };

    El.prototype.current = function () {
      var w = this.slides.clientWidth || 1;
      return Math.round(this.slides.scrollLeft / w);
    };
    /* The track is a scroll-snap row in the carousel and a grid in the
       two-column layout, so which axis "go to image 3" means depends on the
       computed display rather than on a flag we would have to keep in step. */
    El.prototype.isGrid = function () {
      return window.getComputedStyle(this.slides).display === 'grid';
    };
    El.prototype.goTo = function (i) {
      var items = this.slides.children;
      if (!items.length) return;
      var index = ((i % items.length) + items.length) % items.length;
      var item = items[index];

      if (this.isGrid()) {
        var r = item.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var offscreen = r.bottom < 0 || r.top > vh;
        if (offscreen) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } else {
        this.slides.scrollTo({ left: item.offsetLeft - this.slides.offsetLeft, behavior: 'smooth' });
      }
      this.syncThumbs(index);
    };
    El.prototype.syncThumbs = function (i) {
      this.thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    };

    return El;
  })();
  if (!customElements.get('keis-gallery')) customElements.define('keis-gallery', KeisGallery);

  /* ============================================================= <keis-heat>
     The KEIS heat + run-time module. Everything it needs comes from product
     metafields, serialised into the JSON script tag by the section.

     {
       "levels":   [{ "name": "Low", "watts": 22, "amps": 1.8 }, ...],
       "scale":    { "min": 0, "max": 60 },        // shared range across garments
       "others":   { "min": 12, "max": 30 },       // where other brands sit
       "why":      "…tooltip copy…",
       "sources":  [{ "label": "B201 5000mAh", "wh": 37, "type": "battery" },
                    { "label": "Bike supply lead", "wh": null, "type": "vehicle" }]
     }
     A source with a null `wh` runs indefinitely (vehicle supply).
     ========================================================================= */

  var KeisHeat = (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.setPrototypeOf(El, HTMLElement);

    El.prototype.connectedCallback = function () {
      var self = this;
      var json = this.querySelector('[type="application/json"]');
      if (!json) return;
      try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
      if (!this.data.levels || !this.data.levels.length) return;

      this.sourceIndex = 0;
      this.levelIndex = this.data.levels.length - 1;   /* default to full heat */

      /* Conversion losses. Real run time is short of the theoretical capacity
         divided by draw; KEIS's own 7.4V figures sit at about 84% of it. */
      var eff = parseFloat(this.getAttribute('data-efficiency'));
      this.efficiency = (isFinite(eff) && eff > 0) ? eff : 1;

      /* Sources are described on the buttons rather than in the JSON, because
         they are assembled from linked battery PRODUCTS and Liquid cannot build
         an object to serialise. Older profiles that still carry a sources array
         in the JSON keep working. */
      var domSources = this.readSources();
      if (domSources.length) this.data.sources = domSources;

      /* Start on the option the markup marks as selected. The Liquid picks it:
         a battery that comes in the box, else an included supply lead. */
      var chips = [].slice.call(this.querySelectorAll('[data-heat-source]'));
      var marked = chips.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
      if (marked > 0) this.sourceIndex = marked;

      this.querySelectorAll('[data-heat-source]').forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          self.sourceIndex = i;
          self.querySelectorAll('[data-heat-source]').forEach(function (b, j) {
            b.setAttribute('aria-pressed', String(i === j));
          });
          self.render();
          self.track();
        });
      });
      this.querySelectorAll('[data-heat-level]').forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          self.levelIndex = i;
          self.querySelectorAll('[data-heat-level]').forEach(function (b, j) {
            b.setAttribute('aria-pressed', String(i === j));
          });
          self.render();
          self.track();
        });
      });

      this.render();
    };

    /* Insights: the run time a customer settled on, as "Product|Battery|
       Setting" in English (the chips are translated, the JSON and the
       data-track names are not). Sent once they stop clicking, so running
       through the options counts the one they stopped on. */
    El.prototype.track = function () {
      var self = this;
      clearTimeout(this.trackTimer);
      this.trackTimer = setTimeout(function () {
        if (!window.keisTrack) return;
        var chip = self.querySelectorAll('[data-heat-source]')[self.sourceIndex];
        var battery = chip ? (chip.getAttribute('data-track') || chip.textContent.replace(/\s+/g, ' ').trim()) : '';
        var level = self.data.levels[self.levelIndex] || {};
        var product = self.getAttribute('data-track-product') || 'Heat explainer';
        window.keisTrack('runtime', 'check', [product, battery, level.name || ''].join('|'));
      }, 1500);
    };

    El.prototype.readSources = function () {
      return [].slice.call(this.querySelectorAll('[data-heat-source]')).map(function (btn) {
        var src = { unlimited: btn.hasAttribute('data-unlimited') };
        var wh = parseFloat(btn.getAttribute('data-wh'));
        if (isFinite(wh) && wh > 0) src.wh = wh;
        var v = parseFloat(btn.getAttribute('data-volts'));
        if (isFinite(v) && v > 0) src.volts = v;
        var ov = btn.getAttribute('data-overrides');
        if (ov) { try { src.runTimeMinutes = JSON.parse(ov); } catch (e) {} }
        return src;
      });
    };

    /* Watts at a level, for the battery currently selected.

       A dual-voltage garment does not draw the same power on both systems, so
       levels[i].watts may be an object keyed by voltage:

         { "name": "High", "watts": { "7.4v": 30, "12v": 45 } }

       Keys are matched by VALUE, not by string: each is parsed to a number and
       the closest to the battery's voltage wins. That way "12", "12v", "12V"
       and "12.0" all resolve, which matters because a Shopify decimal metafield
       returns 12.0 where the JSON almost certainly says 12.

       A plain number is still accepted and used for every battery, so garments
       written before this keep working. */
    El.prototype.wattsFor = function (level, source) {
      var w = level && level.watts;
      if (w == null) return null;
      if (typeof w === 'number') return w;
      if (typeof w !== 'object') return Number(w) || null;

      var volts = (source && source.volts != null) ? source.volts : null;
      var best = null, bestDiff = Infinity, only = null, count = 0;

      Object.keys(w).forEach(function (k) {
        var kv = parseFloat(k);
        if (w[k] == null) return;
        count++; only = w[k];
        if (!isFinite(kv) || volts == null) return;
        var diff = Math.abs(kv - volts);
        if (diff < bestDiff) { bestDiff = diff; best = w[k]; }
      });

      if (best != null) return Number(best);
      if (count === 1) return Number(only);   /* one figure given — use it */
      return null;
    };

    El.prototype.render = function () {
      var d = this.data;
      var level = d.levels[this.levelIndex];
      var source = (d.sources || [])[this.sourceIndex];
      var scale = d.scale || { min: 0, max: 60 };
      var span = Math.max(1, scale.max - scale.min);

      /* Heat output meter */
      var watts = this.wattsFor(level, source);
      var pct = Math.max(0, Math.min(100, (((watts || 0) - scale.min) / span) * 100));
      var fill = this.querySelector('[data-heat-fill]');
      if (fill) {
        fill.style.width = pct + '%';
        /* backgroundColor, not the background shorthand. A shorthand carrying a
           var() becomes a pending-substitution value, so the longhand no longer
           reports what is painted — and the shorthand also resets every other
           background property on its way past. */
        fill.style.backgroundColor = this.levelIndex === 0
          ? 'var(--heat-1)' : this.levelIndex === 1 ? 'var(--heat-2)' : 'var(--heat-3)';
      }
      var name = this.querySelector('[data-heat-name]');
      if (name) {
        /* The chip's own text, not the JSON's: the chip is drawn in Liquid in
           the visitor's language, the JSON only ever holds the English. */
        var chip = this.querySelectorAll('[data-heat-level]')[this.levelIndex];
        var shown = (chip && chip.textContent.trim()) || level.name;
        name.textContent = watts == null
          ? shown
          : shown + ' · ' + watts + 'W';
      }

      /* "Others" marker — where competing garments sit at THIS heat setting.
         Accepts, in order of preference:
           levels[i].others   { min, max }   per-level, co-located with the level
           others[i]          { min, max }   a list aligned to levels
           others             { min, max }   one static range (older shape)
         so existing products keep working while new ones can move the marker. */
      var others = level.others
                || (Array.isArray(d.others) ? d.others[this.levelIndex] : d.others);
      var marker = this.querySelector('[data-heat-others]');
      if (marker) {
        if (others && others.min != null && others.max != null) {
          var mid = ((((others.min + others.max) / 2) - scale.min) / span) * 100;
          marker.style.left = Math.max(0, Math.min(100, mid)) + '%';
          marker.hidden = false;
        } else {
          marker.hidden = true;
        }
      }

      /* Run time. Authored directly in minutes per level — far easier to copy
         off a spec sheet than a watt-hour figure the theme then divides. */
      var runEl = this.querySelector('[data-run-name]');
      var runFill = this.querySelector('[data-run-fill]');
      if (!source) return;

      if (source.unlimited) {
        if (runEl) runEl.textContent = d.vehicleLabel || T('heatUnlimited', 'Unlimited — runs from the bike');
        if (runFill) runFill.style.width = '100%';
        return;
      }

      var mins = this.minutesFor(source, level, watts);
      if (mins == null) {
        if (runEl) runEl.textContent = '—';
        if (runFill) runFill.style.width = '0%';
        return;
      }
      if (runEl) runEl.textContent = this.formatMinutes(mins);
      if (runFill) {
        /* Scale derived from the longest run time in this profile, so the bar
           is always meaningfully full without anyone configuring a maximum. */
        var ceiling = this.longestRun() || mins;
        runFill.style.width = Math.max(0, Math.min(100, (mins / ceiling) * 100)) + '%';
      }
    };

    /* Minutes for a source at a level. Prefers the authored figure; falls back
       to deriving from watt-hours so older profiles keep working. */
    El.prototype.minutesFor = function (source, level, watts) {
      /* An override is a measured figure and is used exactly as given. Only the
         derived figure carries the efficiency factor — applying it to a bench
         result would derate a number that already accounts for the losses. */
      var table = source.runTimeMinutes;
      if (table && table[level.name] != null) return Number(table[level.name]);
      if (watts == null) watts = this.wattsFor(level, source);
      if (source.wh != null && watts > 0) {
        return (source.wh * (this.efficiency || 1) / watts) * 60;
      }
      return null;
    };

    El.prototype.longestRun = function () {
      var self = this, best = 0;
      (this.data.sources || []).forEach(function (src) {
        if (src.unlimited) return;
        (self.data.levels || []).forEach(function (lvl) {
          var m = self.minutesFor(src, lvl, self.wattsFor(lvl, src));
          if (m != null && m > best) best = m;
        });
      });
      return best;
    };

    /* Durations were the only strings with no Liquid source at all — "min",
       "hour", "hours" were written straight into this file and so stayed English
       in every language. They now come from the bundle, as whole phrases rather
       than a number glued to a unit, because word order and pluralisation are
       not the same everywhere. */
    /* Quoted as a ceiling and rounded to the nearest 10 minutes: "Up to 3h
       30m". The figure is a calculation, and cold, battery age and storage
       all take time off it, so a round "up to" is honest where "3h 27m"
       claims a precision nobody can deliver. The comparison table in the
       KEIS app formats its run times the same way. The wording, "Up to" included,
       is in the locale file under products.duration. */
    El.prototype.formatMinutes = function (total) {
      if (!isFinite(total) || total <= 0) return T('heatUnavailable', '—');
      total = Math.max(10, Math.round(total / 10) * 10);
      var h = Math.floor(total / 60);
      var m = total % 60;
      var body;
      if (h === 0) {
        body = T('durMinutes', '{count} min').replace('{count}', m);
      } else if (m === 0) {
        var one = h === 1;
        body = T(one ? 'durHoursOne' : 'durHoursOther', one ? '{count} hour' : '{count} hours')
                 .replace('{count}', h);
      } else {
        body = T('durHoursMinutes', '{hours}h {minutes}m')
                 .replace('{hours}', h)
                 .replace('{minutes}', m);
      }
      return T('durUpTo', 'Up to {duration}').replace('{duration}', body);
    };

    return El;
  })();
  if (!customElements.get('keis-heat')) customElements.define('keis-heat', KeisHeat);

  /* ======================================================= heat nudge prompt
     A short bounce on the chevron the first time the closed module scrolls
     into view, to say that it opens. Deliberately restrained:

     - once per session, so it is a prompt rather than a tic;
     - never after the customer has opened it, here or on a previous page;
     - never when the OS asks for reduced motion, checked in JS as well as CSS
       so the observer does not run at all;
     - the attribute is removed on open, which stops it mid-bounce.
     ===================================================================== */

  (function () {
    var SEEN = 'keis:heat-opened';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function hasOpenedBefore() {
      try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
    }
    function remember() {
      try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    }

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.classList || !d.classList.contains('keis-heat__disclosure')) return;
      if (d.open) { d.removeAttribute('data-nudge-run'); remember(); }
    }, true);

    if (reduce || hasOpenedBefore()) return;

    var targets = document.querySelectorAll('.keis-heat__disclosure[data-heat-nudge]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (d) { if (!d.open) d.setAttribute('data-nudge-run', ''); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var d = entry.target;
        io.unobserve(d);
        if (!d.open) d.setAttribute('data-nudge-run', '');
      });
    }, { threshold: 0.6 });

    targets.forEach(function (d) { io.observe(d); });
  })();

  /* ========================================================== <keis-countdown>
     Every label and the deadline come off the element, put there by Liquid, so
     nothing here is English and nothing here is a hard-coded date.

     The clock is driven off the wall time each tick rather than by decrementing
     a counter — a decremented counter drifts, and stops entirely when a phone
     backgrounds the tab. Comparing against Date.now() means the timer is right
     the instant the tab comes back.
     ===================================================================== */

  var KeisCountdown = (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.setPrototypeOf(El, HTMLElement);

    var UNITS = ['days', 'hours', 'mins', 'secs'];

    El.prototype.connectedCallback = function () {
      var self = this;
      this.deadline = Date.parse(this.getAttribute('data-deadline'));
      if (!isFinite(this.deadline)) return;              /* unparseable — stay put */

      this.onExpire   = this.getAttribute('data-expire') || 'hide';
      this.showSecs   = this.getAttribute('data-show-seconds') !== 'false';
      this.hideEmpty  = this.getAttribute('data-hide-empty') !== 'false';
      this.expiredEl  = this.querySelector('[data-cd-expired]');
      this.summaryEl  = this.querySelector('[data-cd-summary]');
      this.unitsEl    = this.querySelector('[data-cd-units]');

      this.labels = {
        days:  [this.getAttribute('data-l-day'),  this.getAttribute('data-l-days')],
        hours: [this.getAttribute('data-l-hour'), this.getAttribute('data-l-hours')],
        mins:  [this.getAttribute('data-l-min'),  this.getAttribute('data-l-mins')],
        secs:  [this.getAttribute('data-l-sec'),  this.getAttribute('data-l-secs')]
      };

      this.cells = {};
      UNITS.forEach(function (u) {
        var wrap = self.querySelector('[data-cd-unit="' + u + '"]');
        if (!wrap) return;
        self.cells[u] = {
          wrap: wrap,
          num: wrap.querySelector('[data-cd-num]'),
          label: wrap.querySelector('[data-cd-label]')
        };
      });
      if (!this.showSecs && this.cells.secs) this.cells.secs.wrap.hidden = true;

      this.tick();
      this.timer = setInterval(function () { self.tick(); }, 1000);

      /* Nothing to draw while the tab is hidden; redraw the moment it returns so
         the numbers are never stale on the first frame the customer sees. */
      this._vis = function () { if (!document.hidden) self.tick(); };
      document.addEventListener('visibilitychange', this._vis);

      this.setupGlitch();
    };

    El.prototype.disconnectedCallback = function () {
      clearInterval(this.timer);
      clearTimeout(this.glitchTimer);
      document.removeEventListener('visibilitychange', this._vis);
    };

    El.prototype.remaining = function () {
      return Math.max(0, this.deadline - Date.now());
    };

    El.prototype.tick = function () {
      var ms = this.remaining();

      if (ms <= 0) {
        clearInterval(this.timer);
        clearTimeout(this.glitchTimer);
        this.expire();
        return;
      }

      var total = Math.floor(ms / 1000);
      var v = {
        days:  Math.floor(total / 86400),
        hours: Math.floor(total % 86400 / 3600),
        mins:  Math.floor(total % 3600 / 60),
        secs:  total % 60
      };
      this.values = v;

      if (this.hideEmpty && this.cells.days) {
        this.cells.days.wrap.hidden = v.days === 0;
      }

      /* A glitch burst owns the digits until it finishes. Skipping the write
         here is what stops the tick and the scramble fighting each other. */
      if (!this.glitching) this.paint(v);

      if (this.summaryEl) {
        this.summaryEl.textContent = T('countdownSummary', '{d}, {h}, {m}')
          .replace('{d}', v.days + ' ' + this.labelFor('days', v.days))
          .replace('{h}', v.hours + ' ' + this.labelFor('hours', v.hours))
          .replace('{m}', v.mins + ' ' + this.labelFor('mins', v.mins));
      }
    };

    El.prototype.labelFor = function (unit, n) {
      var pair = this.labels[unit] || [];
      return (n === 1 ? pair[0] : pair[1]) || '';
    };

    El.prototype.pad = function (n) { return n < 10 ? '0' + n : String(n); };

    El.prototype.paint = function (v) {
      var self = this;
      UNITS.forEach(function (u) {
        var c = self.cells[u];
        if (!c) return;
        var text = u === 'days' ? String(v[u]) : self.pad(v[u]);
        c.num.textContent = text;
        c.num.setAttribute('data-cd-text', text);      /* the CSS slices read this */
        if (c.label) c.label.textContent = self.labelFor(u, v[u]);
      });
    };

    El.prototype.expire = function () {
      if (this.onExpire === 'hide') { this.hidden = true; return; }
      if (this.onExpire === 'message') {
        if (this.unitsEl) this.unitsEl.hidden = true;
        if (this.expiredEl) this.expiredEl.hidden = false;
        return;
      }
      this.paint({ days: 0, hours: 0, mins: 0, secs: 0 });   /* 'zeros' */
    };

    /* ------------------------------------------------------------- the glitch */

    El.prototype.setupGlitch = function () {
      if (!this.hasAttribute('data-glitch')) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.glitchGap = Math.max(1, Number(this.getAttribute('data-glitch-gap')) || 6) * 1000;
      this.glitchRandom = this.hasAttribute('data-glitch-random');
      this.scheduleGlitch();
    };

    El.prototype.scheduleGlitch = function () {
      var self = this;
      var gap = this.glitchGap;
      /* Jitter between two-thirds and one-and-a-half times the gap, so it reads
         as a fault rather than a metronome. */
      if (this.glitchRandom) gap = gap * (0.66 + Math.random() * 0.84);
      this.glitchTimer = setTimeout(function () { self.runGlitch(); }, gap);
    };

    El.prototype.runGlitch = function () {
      var self = this;
      if (document.hidden || this.remaining() <= 0) { this.scheduleGlitch(); return; }

      this.glitching = true;
      this.classList.add('is-glitching');

      var frames = 5 + Math.floor(Math.random() * 3);
      var n = 0;

      (function step() {
        if (n++ >= frames) {
          /* Always restored from the real remaining time, never from a saved
             copy — so however the burst ends, the true figure is what lands. */
          self.glitching = false;
          self.classList.remove('is-glitching');
          self.tick();
          self.scheduleGlitch();
          return;
        }
        UNITS.forEach(function (u) {
          var c = self.cells[u];
          if (!c || c.wrap.hidden) return;
          var len = c.num.textContent.length || 2;
          var junk = '';
          for (var i = 0; i < len; i++) junk += Math.floor(Math.random() * 10);
          c.num.textContent = junk;
          c.num.setAttribute('data-cd-text', junk);
        });
        setTimeout(step, 40 + Math.random() * 45);
      })();
    };

    return El;
  })();
  if (!customElements.get('keis-countdown')) customElements.define('keis-countdown', KeisCountdown);

  /* ================================================================ <keis-reel>
     Social proof videos: circle at rest, rounded square playing muted on hover,
     full sound in a dialog on click.

     Nothing is fetched until it is wanted. The <video> elements start with no
     source at all; the URLs sit in a JSON script tag and are only attached when
     a pointer actually lands on a clip. A row of six autoloading clips on a page
     that already carries a product gallery is a real cost on mobile.
     ========================================================================= */

  var KeisReel = (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.setPrototypeOf(El, HTMLElement);

    El.prototype.connectedCallback = function () {
      var self = this;
      this.items = [].slice.call(this.querySelectorAll('[data-reel-item]'));
      if (!this.items.length) return;

      this.dialog = this.querySelector('[data-reel-dialog]');
      this.full = this.querySelector('[data-reel-video]');
      this.stage = this.querySelector('[data-reel-stage]');
      this.caption = this.querySelector('[data-reel-caption]');

      /* Hover previews are pointer-only. On touch there is no hover, and a tap
         should open the dialog rather than start a silent preview under the
         finger. */
      this.canHover = window.matchMedia &&
                      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.reduced = window.matchMedia &&
                     window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach(function (btn, i) {
        if (self.canHover && !self.reduced) {
          btn.addEventListener('mouseenter', function () { self.preview(btn, i); });
          btn.addEventListener('focus', function () { self.preview(btn, i); });
          btn.addEventListener('mouseleave', function () { self.stop(btn); });
          btn.addEventListener('blur', function () { self.stop(btn); });
        }
        btn.addEventListener('click', function () { self.open(i); });
      });

      /* Whatever closes the dialog — the button, Escape, the overlay — the
         video must stop. Leaving it playing behind a closed dialog is a sound
         the customer cannot find the source of. */
      /* keis-drawer emits on document, not on itself, so this listens there and
         filters by id. */
      if (this.dialog) {
        document.addEventListener('keis:drawer:close', function (e) {
          if (e.detail && e.detail.id === self.dialog.id) self.reset();
        });
      }
    };

    El.prototype.data = function (i) {
      var tag = this.querySelector('[data-reel-sources="' + i + '"]');
      if (!tag) return null;
      try { return JSON.parse(tag.textContent); } catch (e) { return null; }
    };

    El.prototype.attach = function (video, data) {
      if (!data || !data.sources || !data.sources.length) return false;
      if (video.dataset.loaded === '1') return true;
      data.sources.forEach(function (s) {
        var el = document.createElement('source');
        el.src = s.url;
        if (s.mime) el.type = s.mime;
        video.appendChild(el);
      });
      video.dataset.loaded = '1';
      video.load();
      return true;
    };

    El.prototype.preview = function (btn, i) {
      var video = btn.querySelector('.keis-reel__preview');
      if (!video) return;
      if (!this.attach(video, this.data(i))) return;
      btn.classList.add('is-previewing');
      var p = video.play();
      /* Autoplay can still be refused. If it is, drop the class so the tile
         does not sit expanded showing a frozen frame. */
      if (p && p.catch) p.catch(function () { btn.classList.remove('is-previewing'); });
    };

    El.prototype.stop = function (btn) {
      var video = btn.querySelector('.keis-reel__preview');
      btn.classList.remove('is-previewing');
      if (!video) return;
      try { video.pause(); video.currentTime = 0; } catch (e) {}
    };

    El.prototype.open = function (i) {
      var data = this.data(i);
      if (!data || !this.full || !this.dialog) return;

      this.reset();
      this.attach(this.full, data);

      /* The dialog takes the clip's own shape, so a phone-shot vertical review
         is not letterboxed into a widescreen box. */
      if (this.stage && data.ratio) this.stage.style.setProperty('--reel-ratio', data.ratio);

      if (this.caption) {
        this.caption.textContent = data.label || '';
        this.caption.hidden = !data.label;
      }

      this.full.muted = false;
      if (this.dialog.open) this.dialog.open(this.items[i]);
      var p = this.full.play();
      if (p && p.catch) p.catch(function () { /* the controls are there */ });
    };

    El.prototype.reset = function () {
      if (!this.full) return;
      try { this.full.pause(); this.full.currentTime = 0; } catch (e) {}
      while (this.full.firstChild) this.full.removeChild(this.full.firstChild);
      this.full.dataset.loaded = '';
    };

    return El;
  })();
  if (!customElements.get('keis-reel')) customElements.define('keis-reel', KeisReel);

  /* ============================================================ bundle toggle */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-toggle]');
    if (!btn) return;
    btn.classList.toggle('is-on');
    btn.setAttribute('aria-pressed', String(btn.classList.contains('is-on')));
  });

  /* ============================================================== quick add */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.quickAdd;
    if (!id) return;
    var label = btn.innerHTML;
    btn.setAttribute('aria-disabled', 'true');
    btn.innerHTML = btn.dataset.adding || T('adding', 'Adding…');
    window.KEIS.cart.add({ items: [{ id: Number(id), quantity: 1 }] })
      .then(function () { return window.KEIS.cart.refresh(); })
      .then(function () {
        var drawer = document.getElementById('keis-cart-drawer');
        if (drawer && drawer.open) drawer.open(btn);
      })
      .catch(function () { /* leave the card untouched; the PDP handles errors */ })
      .finally(function () { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; });
  });
})();

/* ========================================================== <keis-viewers>
   "Viewed today". Shopify exposes no pageview count, so this renders only
   what a configured endpoint reports. There is no fallback number and no
   synthetic figure — if the endpoint is absent or fails, the line stays
   hidden.

   Contract:
     POST <endpoint>  { productId, handle }  ->  200 { "count": <integer> }
   ========================================================================= */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('[data-viewers]');
    if (!el || !el.dataset.endpoint) return;

    var min = Number(el.dataset.min || 0);
    var tpl = el.dataset.template || T('viewers', '{count} people viewed this today');

    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 4000);

    fetch(el.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: el.dataset.productId,
        handle: el.dataset.handle
      }),
      signal: controller.signal,
      credentials: 'omit'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var count = parseInt(data.count, 10);
        /* Below the minimum a real count reads as weak rather than urgent,
           so the line stays hidden rather than showing "1 person". */
        if (!isFinite(count) || count < min) return;
        el.querySelector('[data-viewers-text]').textContent = tpl.replace('{count}', count);
        el.hidden = false;
      })
      .catch(function () { /* endpoint down — stay hidden rather than invent */ })
      .finally(function () { clearTimeout(timer); });
  });
})();

/* ================================================ award marks on the photo
   The KEIS app pins award marks (Ride Recommended, ABR…) beside the product
   title. On a phone the title sits above the photos, and the mark reads
   better on the main photo itself, top left, the way a printed award sits on
   a box. So below the two-column width the app's slot moves into the
   gallery's corner badges, and back beside the title when the screen widens.

   The app finds its slot by [data-keis-icons] wherever it is and never adds a
   second, so moving it is safe. It arrives after the app's data loads, so the
   title block is watched until it does. */
(function () {
  'use strict';
  var title = document.querySelector('.keis-buybox__title');
  var corner = document.querySelector('.keis-pdp .keis-gallery__badges');
  if (!title || !corner || !window.matchMedia) return;
  var narrow = window.matchMedia('(max-width: 989px)');

  function place() {
    var slot = document.querySelector('[data-keis-icons]');
    if (!slot) return false;
    if (narrow.matches) {
      if (slot.parentNode !== corner) corner.insertBefore(slot, corner.firstChild);
      slot.classList.add('kss-slot--photo');
    } else {
      if (slot.parentNode !== title) title.appendChild(slot);
      slot.classList.remove('kss-slot--photo');
    }
    return true;
  }

  if (!place() && 'MutationObserver' in window) {
    var watch = new MutationObserver(function () { if (place()) watch.disconnect(); });
    watch.observe(title, { childList: true });
  }
  if (narrow.addEventListener) narrow.addEventListener('change', place);
  else if (narrow.addListener) narrow.addListener(place);
})();

/* ===================================== Judge.me: the review title expands it
   Judge.me expands a cut-short review when its text or its small "more" is
   tapped, but not its title, which is where many taps land (session
   recordings, Oct 2026). A tap on the title presses the review's own "more". */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var title = e.target.closest && e.target.closest('.jm-review-content__title');
    if (!title) return;
    var card = title.closest('.jm-review-content');
    var more = card && card.querySelector('.jm-review-content__expand-button');
    if (more) more.click();
  });
})();
